/* 🧩 COMPONENTS */
import { EquipamentLine } from "../index.js"

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store/index.js";
import { ChangeEquipamentDataList } from "../../../../Redux/Actions/mapActions.js";

/* 📁 ASSETS*/
import { Fixado } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, UnpinButton, UnpinImage } from "./styles"

const EquipamentCard = (props) => {

    let dados = props.dados
    let status = props.status

    const handleUnpinCard = () => {
        let list = JSON.parse(JSON.stringify(store.getState().mapReducer.EquipamentDataList));
        list = list.filter(equipament => equipament.id !== props.id[0]);
        store.dispatch(ChangeEquipamentDataList(list));
    }

    return(
        <Container>
            <UnpinButton id="close-card" onClick={() => handleUnpinCard()}>
                <UnpinImage src={Fixado} id={`${props.id[1]}`}/>
            </UnpinButton>
            <TitleContainer $background={status === 4 ? '#E1800E' : status === 3 ? '#6600CC' : status === 2 ? 
                '#FF3939': status === 1 ? '#EABC1A' : status === 0 ? '#33CC99' : '#F6F6F6'}>
                <Title $background={status === 4 ? '#E1800E' : status === 3 ? '#6600CC' : status === 2 ? 
                '#FF3939': status === 1 ? '#EABC1A' : status === 0 ? '#33CC99' : '#F6F6F6'}>{props.equipamento}</Title>
            </TitleContainer>
            {dados.map((dado, index) => (
                <EquipamentLine key={index} dado={dado}/>
            ))}
        </Container>
    )
}

export default EquipamentCard;